define('views/components/action_history/action_history_list',['require','views/base/list_view','views/components/action_history/action_history','text!templates/components/action_history/action_history_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/action_history/action_history');

    var temp = require("text!templates/components/action_history/action_history_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

